export default __webpack_public_path__ + "static/media/productbanner.d5fb0ea30dd27d87129d045c6daa8a83.svg";